/** Pure Ultima Online hue encoding helpers shared by DOM and Pixi renderers. */

export const PARTIAL_HUE_CHROMA_THRESHOLD = 0.18;
export const PARTIAL_HUE_FLAG = 0x8000;
export const SPECTRAL_HUE_FLAG = 0x4000;
export const HUE_INDEX_MASK = 0x3fff;

export interface UoHueMode {
  paletteHue: number;
  partial: boolean;
  spectral: boolean;
}

/** The chroma `max(rgb) - min(rgb)` of a 0..1 RGB pixel. */
export function chromaOf(r: number, g: number, b: number): number {
  return Math.max(r, g, b) - Math.min(r, g, b);
}

/** Whether a pixel is gray enough for ClassicUO's partial-hue path. */
export function isNearGray(r: number, g: number, b: number): boolean {
  return chromaOf(r, g, b) <= PARTIAL_HUE_CHROMA_THRESHOLD;
}

/** Decode the palette id and ClassicUO mode flags carried by a wire hue. */
export function decodeUoHue(encodedHue: number, partial = false): UoHueMode {
  return {
    paletteHue: encodedHue & HUE_INDEX_MASK,
    partial: partial || (encodedHue & PARTIAL_HUE_FLAG) !== 0,
    spectral: (encodedHue & SPECTRAL_HUE_FLAG) !== 0,
  };
}
